export default "__VITE_ASSET__B9C05EaP__"